import appConstants from "../../../../../appConstants";
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getGroupedCustomers(params) {
    return params.data.duplicateCustomers
      .map((customer) => customer.duplicateCustomerName)
      .join(",");
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.MergedCustomerGrid,
      keyColumn: "customerID",
      rowSelection: "single",
      rowDeselection: true,
      columns: [
        {
          headerName: "Acc #",
          field: "originalCustomerCode",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_100,
        },
        {
          headerName: "Customer",
          field: "originalCustomerName",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_250,
          tooltipField: "originalCustomerName",
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: "Aliases #",
          field: "aliasesCount",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_100,
          valueGetter: (params) => params.data.duplicateCustomers.length,
        },
        {
          headerName: "Grouped Customers",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_250,
          valueGetter: GridConfig.getGroupedCustomers,
          tooltipValueGetter: (params) => params.value,
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: "Address",
          field: "originalCustomerAddress",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_250,
          tooltipField: "originalCustomerAddress",
          filterParams:{
            width: appConstants.columnWidth.W_300
          }
        },
        {
          headerName: "City",
          field: "originalCustomerCity",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "State",
          field: "originalCustomerState",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_90,
        },
        {
          headerName: "Zip",
          field: "originalCustomerZip",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_100,
        },
      ],
    };
  }
}
